var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('a',{attrs:{"href":`/${_vm.$i18n.locale}/top`}},[_c('v-img',{staticClass:"header-logo",attrs:{"src":require('@/assets/images/views/common/header-logo.svg'),"contain":"","aspect-ratio":"4"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }